import { useState } from "react";
import { syncOrders } from "../services/api";
import { RefreshCw, CheckCircle, AlertCircle } from "lucide-react";

export default function SyncButton({ onSyncSuccess }) {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("idle"); // idle, success, error

  const handleSync = async () => {
    setLoading(true);
    setStatus("idle");

    try {
      await syncOrders();
      setStatus("success");
      onSyncSuccess && onSyncSuccess();
      setTimeout(() => setStatus("idle"), 3000);
    } catch (err) {
      setStatus("error");
      setTimeout(() => setStatus("idle"), 3000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center md:items-end gap-2 w-full md:w-auto">
      <button
        className={`flex items-center justify-center gap-2 md:px-5 px-3 py-3 md:py-2.5 text-md md:text-base rounded-xl font-bold transition-all duration-300 shadow-lg w-full md:w-auto ${loading
          ? "bg-indigo-100 text-indigo-400 cursor-not-allowed"
          : status === "success"
            ? "bg-green-500 text-white shadow-green-200"
            : status === "error"
              ? "bg-red-500 text-white shadow-red-200"
              : "bg-indigo-600 hover:bg-indigo-700 text-white shadow-indigo-200 hover:-translate-y-0.5"
          }`}
        onClick={handleSync}
        disabled={loading}
      >
        <RefreshCw size={18} className={loading ? "animate-spin" : ""} />
        <span>
          {loading ? "Syncing Logic..." : status === "success" ? "Synced!" : status === "error" ? "Failed" : "Sync Sheets"}
        </span>
      </button>

      {status === "success" && (
        <div className="flex items-center gap-1.5 text-green-600 text-[10px] md:text-xs font-bold animate-in fade-in slide-in-from-top-1 px-1">
          <CheckCircle size={14} />
          <span>Orders synchronized</span>
        </div>
      )}

      {status === "error" && (
        <div className="flex items-center gap-1.5 text-red-600 text-[10px] md:text-xs font-bold animate-in fade-in slide-in-from-top-1 px-1">
          <AlertCircle size={14} />
          <span>Sync failed</span>
        </div>
      )}
    </div>
  );
}
